import { GiftCard, GiftCardVariant } from './giftCard';
import { CustomerPlacement } from './cartOperations';
import { BundleConfigs } from './cartItem';

export interface StandardProduct {
  id: string;
  brand: string;
  category: string;
  description: string;
  descriptionHtml: string;
  images: string[];
  name: string;
  type: string;
  isSuppressed: boolean;
  variants: Variant[];
  statesAvailability: string[];
  isBundle: false;
  bundleConfigs: never;
}

export interface BundleProduct {
  id: string;
  brand: string;
  category: string;
  description: string;
  descriptionHtml: string;
  images: string[];
  name: string;
  type: string;
  isSuppressed: boolean;
  variants: Variant[];
  statesAvailability: string[];
  isBundle: true;
  price: string;
  bundleConfigs: BundleConfigs;
}

export interface Variant {
  availability: Array<'onDemand' | 'shipped' | 'engraved'>;
  engravingConfigs: EngravingConfigs;
  images: string[];
  packSize: string;
  productId: number;
  retailers: Retailer[];
  size: string;
  presale: PreSale;
}

export interface EngravingConfigs {
  active: boolean;
  characters: number;
  lines: number;
  location: string;
}

export interface Retailer {
  variantId: number;
  retailer: RetailerInfo;
  type: string;
  price: string;
  inStock: number;
  engraving: boolean;
  customerPlacement: CustomerPlacement;
  shippingMethod: ShippingMethod;
}

export interface RetailerInfo {
  id: number;
  name: string;
  address: Address;
  shippingMethods: ShippingMethod[];
}

export interface Address {
  id: number;
  address1: string;
  address2: null;
  city: string;
  stateName: string;
  zipCode: string;
  latitude: number;
  longitude: number;
}

export interface ShippingMethod {
  id: number;
  type: string;
  min: number;
  max: number;
  fee: number;
  deliveryExpectation: string;
  shortDeliveryExpectation: string;
  deliveryHours: DeliveryHours;
  /**
   *  @deprecated
   *  use `deliveryExpectation` or `shortDeliveryExpectation` string instead
   * */
  desc: Desc;
}

export interface DeliveryHours {
  sun: Array<string[]>;
  mon: Array<string[]>;
  tue: Array<string[]>;
  wed: Array<string[]>;
  thu: Array<string[]>;
  fri: Array<string[]>;
  sat: Array<string[]>;
}

export interface Desc {
  expected: string;
  backOrder: string;
}

export interface PreSale {
  active: boolean;
  purchasable: boolean;
  expectedDeliveryDate?: Date | string | number;
  startAt?: Date | string | number;
}

export type Product = StandardProduct | GiftCard | BundleProduct;

export function isProductVariant(variant: Variant | GiftCardVariant): variant is Variant {
  return (variant as Variant).retailers !== undefined;
}
